export const AGENT_NAME_KEY = "pitcherly_agent_name";
export const AGENT_SIGNOFF_KEY = "pitcherly_agent_signoff";
export const COMPANY_NAME_KEY = "pitcherly_company_name";
export const LOGO_KEY = "pitcherly_logo";
export const HEADSHOT_KEY = "pitcherly_headshot";
export const CONTACTS_KEY = "pitcherly_contacts";
export const DISPLAY_NAME_KEY = "pitcherly_display_name";

// ─── Changelog / What's New ─────────────────────────────────────────────────
export const WHATS_NEW_KEY = "pitcherly_whats_new_seen";
export const WHATS_NEW_VERSION = "2026-04";
export const CHANGELOG = [
  {
    version: "2026-04",
    date: "April 2026",
    title: "Polish & Reliability",
    items: [
      "Export listings as PDF directly from the output panel",
      "Bulk actions in Contacts — multi-select, delete, and export CSV",
      "Error boundary catches unexpected UI crashes with recovery",
      "In-app toast notifications replaced blocking alerts",
      "Keyboard shortcut: Cmd/Ctrl+Enter to generate",
      "Account deletion from the Account page (full data wipe)",
      "Faster, rate-limited generation endpoints",
    ],
  },
];

export const COMING_FEATURES = [
  { name: "Gmail & Outlook Integration", desc: "Send generated emails directly from Pitcherly without copy-pasting. Connect your inbox and send in one click.", badge: "Most Requested", badgeCls: "accent" },
  { name: "Social Media Scheduler", desc: "Schedule your Just Sold posts, listing announcements, and neighborhood content directly to Instagram, Facebook, and LinkedIn.", badge: "Coming Q2", badgeCls: "green" },
  { name: "Chrome Extension", desc: "Generate listing copy and emails directly inside Zillow, MLS, and your CRM without switching tabs.", badge: "In Development", badgeCls: "blue" },
  { name: "Team & Brokerage Accounts", desc: "Add your whole team under one account. Perfect for brokerages who want every agent using Pitcherly.", badge: "Coming Q2", badgeCls: "green" },
  { name: "MLS Auto-Fill", desc: "Connect your MLS and pull property data automatically. No more manual entry.", badge: "Coming Q3", badgeCls: "muted" },
  { name: "Market Report Generator", desc: "Monthly market reports you can send to your farm list. Branded, professional, data-driven.", badge: "Coming Q3", badgeCls: "muted" },
  { name: "Listing Presentation Deck", desc: "A full AI-generated seller presentation deck you can walk into any listing appointment with.", badge: "Coming Q3", badgeCls: "muted" },
  { name: "Zapier Integration", desc: "Connect Pitcherly to 5,000+ apps. Auto-send emails, log to CRM, trigger workflows.", badge: "Coming Q2", badgeCls: "green" },
];
